'use strict';

angular.module('gov.directives', []);